






















































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/workorder/workorderpagepo";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";
import SearchTree from "@/lib/Common/searchtree";
import Moment from "moment-timezone";
import TransmitModal from './transmit.vue'
import ProcessModal from './process.vue';
import RescindModal from './rescind.vue';
import FlowPath from '@/views/workordercenter/workorder/flowpath.vue';



@Component({
    components: { TransmitModal, ProcessModal, RescindModal, FlowPath },
})
export default class WorkOrder extends AbpBase {

    pagerequest: PageRequest = new PageRequest();
    creationTime: Date[] = [];
    /**处理 */
    processModalShow: boolean = false;//
    /**转交 */
    transmitModalShow: boolean = false;
    /**撤消 */
    rescindModalShow: boolean = false;
    /**全链路查看过程 */
    flowpathModalShow: boolean = false;
    /**工单编号 */
    workorderId: number = 0;
    treedata: any[] = [];
    areaTreeList: any[] = [];
    searchName: string = "";
    splitnum: number = 0.15;
    statelist: any[] = [];
    ordertypelist: any[] = [];
    orderlevel: any[] = [];
    problemtype: any[] = [];

    get list() {
        return this.$store.state.workorder.list;
    }
    get loading() {
        return this.$store.state.workorder.loading;
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.treedata = this.areaTreeList;
            return;
        }
        //this.treedata = [];
        this.treedata = SearchTree.searnchTree(value, treeList);
    }
    /**获取左边区域树形结构 */
    async itemtree() {
        await this.$store
            .dispatch("area/getAreaLeftTree")
            .then((val) => {
                this.treedata = val;
                this.areaTreeList = val;
            })
            .catch((err) => {
                //return null;
            });
    }
    /**状态 */
    async getState() {
        await this.$store.dispatch("workorder/getWorkOrderState")
            .then((result) => {
                this.statelist = [];
                this.statelist.push({ value: 0, label: this.L('All') });
                if (result.status === 200 && result.data.success) {
                    if (result.data.result.length > 0) {
                        result.data.result.forEach((ele) => {
                            this.statelist.push({ value: ele.id, label: this.L(ele.label) })
                        });
                        localStorage.setItem('workOrderState', JSON.stringify(this.statelist))
                    }
                }
            })
            .catch((err) => {
                //return null;
            });
    }
    /**获取工单类型、问题类型、紧急程序 */
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));

        if (detaillist.length > 0) {
            let info = detaillist.filter((p) => {
                return p.itemId == 26;
            });
            this.ordertypelist = [];
            this.ordertypelist.push({ value: 0, label: this.L('All') });
            info.forEach((ele) => {
                this.ordertypelist.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            let pro = detaillist.filter((p) => {
                return p.itemId == 27;
            });
            this.problemtype = [];
            this.problemtype.push({ value: 0, label: this.L('All') });
            pro.forEach((ele) => {
                this.problemtype.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            let metert = detaillist.filter((p) => {
                return p.itemId == 28
            });
            this.orderlevel = [];
            this.orderlevel.push({ value: 0, label: this.L('All') });
            metert.forEach((ele) => {
                this.orderlevel.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
        }
    }
    pageChange(page: number) {
        this.$store.commit("workorder/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("workorder/setPageSize", pagesize);
        this.getpage();
    }
    changeSort(key) {
        this.pagerequest.sorting = key.key + " " + key.order;
        this.getpage();
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.areaId = item[0].id;
        }
        this.$store.commit("workorder/setCurrentPage", 1);
        this.getpage();
    }
    getSearch() {
        this.$store.commit("workorder/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "workorder/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.workorder.pageSize;
    }
    get totalCount() {
        return this.$store.state.workorder.totalCount;
    }
    get currentPage() {
        return this.$store.state.workorder.currentPage;
    }
    /**检测按钮权限 */
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    /**撤消 */
    rescind(id: number) {
        this.workorderId = id;
        this.rescindModalShow = true;
    }
    /**转交
     * 
     */
    transmit(id: number) {
        this.workorderId = id;
        this.transmitModalShow = true;
    }
    /**处理 */
    process(id: number) {
        this.workorderId = id;
        this.processModalShow = true;
    }
    /**查看全流程明细 */
    florwpath(id: number) {
        this.workorderId = id;
        this.flowpathModalShow = true;
    }
    columns = [
        {
            title: this.L("IndexNo"),
            type: "index",
            width: 70,
            align: "left",
            fixed: "left",
        },
        {
            title: this.L("Number"),
            key: "orderNo",
            width: 160,
            fixed: "left",
            sortable: true,
        },
        {
            title: this.L("Organizations"),
            key: "organizationId",
            width: 150,
            sortable: true,
            render: (h: any, params: any) => {
                let id = params.row.organizationId;
                let ite = JSON.parse(localStorage.getItem("organizations"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].displayName : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("Areas"),
            key: "areaId",
            sortable: true,
            width: 130,
            resizable: true,
            sortId: 6,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Title"),
            width: 160,
            key: "title",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.title,
                        },
                    },
                    params.row.title
                );
            },
        },
        {
            title: this.L("WorkOrderType"),
            width: 160,
            key: "orderTypeId",
            render: (h: any, params: any) => {
                let id = params.row.orderTypeId;
                let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
                let info = detaillist.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].name : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].name : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("ProblemType"),
            width: 160,
            key: "problemTypeId",
            render: (h: any, params: any) => {
                let id = params.row.problemTypeId;
                let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
                let info = detaillist.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].name : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].name : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("OrderLevel"),
            width: 160,
            key: "orderLevelId",
            render: (h: any, params: any) => {
                let id = params.row.problemTypeId;
                let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
                let info = detaillist.filter((p) => {
                    return p.id == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].name : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].name : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("Description"),
            width: 160,
            key: "description",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.description,
                        },
                    },
                    params.row.description
                );
            },
        },
        // {
        //     title: this.L("deviceId"),
        //     width: 160,
        //     key: "deviceId",
        //     display:'none'
        // },
        {
            title: this.L("DeviceNo"),
            width: 160,
            key: "deviceNo",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.deviceNo,
                        },
                    },
                    params.row.deviceNo
                );
            },
        },
        {
            title: this.L("Location"),
            width: 160,
            key: "location",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.location,
                        },
                    },
                    params.row.location
                );
            },
        },
        {
            title: this.L("Applicant"),
            width: 160,
            key: "applicant",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.applicant,
                        },
                    },
                    params.row.applicant
                );
            },
        },
        {
            title: this.L("ApplyTime"),
            width: 160,
            key: "applyTime",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.applyTime == null
                        ? ""
                        : Moment(params.row.applyTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("Contacter"),
            width: 160,
            key: "contacts",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.contacts,
                        },
                    },
                    params.row.contacts
                );
            },
        },
        {
            title: this.L("Tel"),
            width: 160,
            key: "mobile",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.mobile,
                        },
                    },
                    params.row.mobile
                );
            },
        },
        {
            title: this.L("Tel"),
            width: 160,
            key: "mobile",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.mobile,
                        },
                    },
                    params.row.mobile
                );
            },
        },
        {
            title: this.L("IsReserva"),
            width: 90,
            key: "isReserva",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.isReserva === true
                        ? "是"
                        : "否"
                );
            },
        },
        {
            title: this.L("ReservaTime"),
            width: 160,
            key: "reservaTime",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.reservaTime == null
                        ? ""
                        : Moment(params.row.reservaTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("DispatchInfo"),
            align: "center",
            children: [
                // {
                //     title: this.L("AssignerID"),
                //     width: 150,
                //     key: "assignerID",
                //     hidden: true,
                // },
                {
                    title: this.L("AssignerName"),
                    width: 150,
                    key: "assignerName",
                    render: (h: any, params: any) => {
                        return h(
                            "span",
                            {
                                style: {
                                    display: "inline-block",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                domProps: {
                                    title: params.row.assignerName,
                                },
                            },
                            params.row.assignerName
                        );
                    },
                },
                {
                    title: this.L("AssignMark"),
                    width: 150,
                    key: "assignMark",
                    render: (h: any, params: any) => {
                        return h(
                            "span",
                            {
                                style: {
                                    display: "inline-block",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                domProps: {
                                    title: params.row.assignMark,
                                },
                            },
                            params.row.assignMark
                        );
                    },
                },
            ],
        },
        {
            title: this.L("ProcessInfo"),
            align: "center",
            children: [
                {
                    title: this.L("ProcessedBy"),
                    width: 150,
                    key: "processedBy",
                    render: (h: any, params: any) => {
                        return h(
                            "span",
                            {
                                style: {
                                    display: "inline-block",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                domProps: {
                                    title: params.row.processedBy,
                                },
                            },
                            params.row.processedBy
                        );
                    },
                },
                {
                    title: this.L("Tel"),
                    width: 150,
                    key: "processedTel",
                    render: (h: any, params: any) => {
                        return h(
                            "span",
                            {
                                style: {
                                    display: "inline-block",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                domProps: {
                                    title: params.row.processedTel,
                                },
                            },
                            params.row.processedTel
                        );
                    },
                },
                {
                    title: this.L("ProcessedResult"),
                    width: 150,
                    key: "processedResult",
                    render: (h: any, params: any) => {
                        return h(
                            "span",
                            {
                                style: {
                                    display: "inline-block",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                },
                                domProps: {
                                    title: params.row.processedResult,
                                },
                            },
                            params.row.processedResult
                        );
                    },
                },
            ],
        },

        {
            title: this.L("OrderState"),
            width: 100,
            key: "orderState",
            fixed: "right",
            render: (h: any, params: any) => {
                let id = params.row.orderState;
                let data = JSON.parse(localStorage.getItem('workOrderState'));
                let info = data.filter((p) => {
                    return p.value == id;
                });
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: info.length > 0 ? info[0].label : this.L("Unknown"),
                        },
                    },
                    info.length > 0 ? info[0].label : this.L("Unknown")
                );
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 310,
            fixed: "right",
            render: (h: any, params: any) => {
                //取消
                let del = this.checkButtonAuth('myWorkOrderCancel');
                //转交
                let tran = this.checkButtonAuth('MyOorkOrderTransfer')
                //处理
                let process = this.checkButtonAuth('myWorkOrderProcess')
                return h("div", [
                    //取消
                    del && params.row.orderState < 4 ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            style: {
                                marginRight: "3px",
                            },
                            on: {
                                click: async () => {
                                    this.workorderId = params.row.id;
                                    this.rescind(params.row.id);
                                },
                            },
                        },
                        this.L("Cancel")
                    ) : '',
                    //转交
                    tran && (params.row.orderState == 2 || params.row.orderState == 3) ? h(
                        "Button",
                        {
                            props: {
                                type: "dashed",
                                size: "small",
                            },
                            style: {
                                marginRight: "3px",
                            },
                            on: {
                                click: async () => {
                                    let id = params.row.id;
                                    this.transmit(id);
                                },
                            },
                        },
                        this.L("Transmit")
                    ) : '',
                    //处理
                    process && (params.row.orderState == 2 || params.row.orderState == 3) ? h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "3px",
                            },
                            on: {
                                click: async () => {
                                    let id = params.row.id;
                                    this.process(id);
                                },
                            },
                        },
                        this.L("Handle")
                    ) : '',
                    //查看
                    h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "3px",
                            },
                            on: {
                                click: async () => {
                                    let id = params.row.id;
                                    this.florwpath(id);
                                },
                            },
                        },
                        this.L("Detail")
                    )
                ]);
            },
        },
    ];
    async created() {
        await this.getState();
        await this.itemtree();
        await this.getItemDetail();
        this.pagerequest.orderLevelId = 0;
        this.pagerequest.problemTypeId = 0;
        this.pagerequest.orderState = 0;
        this.pagerequest.orderTypeId = 0;
        this.pagerequest.isPersion = 1;
        await this.getpage();
    }
    data() {
        return {
            paytype: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
